import { useCallback } from "react";
import * as Utils from "core/common/utils";
import { setCurrentBusiness, setLookupData } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";
import { SUBBUSINESS_ID_LOCAL_STORAGE_KEY } from "core/common/constants/localstorage";
import * as TagManager from "core/common/seo/tagManager";
import useJwtTokenData from "core/custom-hooks/useJwtTokenData";
import { trySetReturnUrl } from "core/route";

const useAppInitialData = () => {
    const { dispatch, businessRepository, lookupRepository, state } = useStore();
    const { business, lookup } = state;
    const { hasAdminRole } = useJwtTokenData();

    const getAppInitialData = useCallback(() => {

        const setData = (responseData, action) => {
            const { data } = responseData;

            if (data) {
                if (Utils.isSuccessfulRequest(dispatch, responseData, true)) {
                    dispatch(action(data));
                }
            }
        };

        Utils.loadingWrapper(dispatch, async () => {

            const subBusinessId = localStorage.getItem(SUBBUSINESS_ID_LOCAL_STORAGE_KEY);

            const tasks = [];

            const isAdmin = hasAdminRole();
          
            const doGetBusiness = !business && (isAdmin && subBusinessId || !isAdmin);
            const doGetLookup = !lookup;

            if (doGetLookup) {
                tasks.push(lookupRepository.get());
            }

            if (doGetBusiness) {
                tasks.push(businessRepository.get(subBusinessId));
            }

            const responses = await Promise.all(tasks);

            const businessHandler = dataResponse => {
                TagManager.sendBusinessId(dataResponse?.data?.data?.business_id);
                setData(dataResponse, setCurrentBusiness);
            };

            const lookupHandler = dataResponse => {
                setData(dataResponse, setLookupData);
            };

            responses.map(a => {
                return {
                    url: a.config.url,
                    responseData: a.data
                }
            }).forEach((r) => {
                if (r.url.startsWith("/meta/lookups")) {
                    lookupHandler(r.responseData);

                } else if (r.url.startsWith("/business")){
                    businessHandler(r.responseData);
                    if(r.responseData?.data?.is_zap_coupons){
                       // trySetReturnUrl("/zap-coupons")
                    }
                }
            });
        });
    });

    return { getAppInitialData };
}

export default useAppInitialData;